import { render, staticRenderFns } from "./groupBooksOrders.vue?vue&type=template&id=45040d3e&"
import script from "./groupBooksOrders.vue?vue&type=script&lang=js&"
export * from "./groupBooksOrders.vue?vue&type=script&lang=js&"
import style0 from "./groupBooksOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports